import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Field from '../../../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'
import MinimisedSection from '../../../../../../../../components/MinimisedSection'
import MinimisedSectionHeader from '../../../../../../../../components/MinimisedSection/MinimisedSectionHeader'

import {
  ASSUMPTION_NAME,
  ASSUMPTIONS,
  assumptionsOptions,
  ATTRIBUTION,
  DEAD_WEIGHT,
  DISPLACEMENT,
  DROP_OFF
} from '../../../fields'

import useStyles from './styles'

const AssumptionSection = ({ formik, index, isSelected, onSelect, onClose, onDelete }) => {
  const { t } = useTranslation()

  const classes = useStyles()

  const { values } = formik

  const availableAssumptionsOptions = useMemo(() => {
    const selectedAssumptionsNames = values[ASSUMPTIONS].map(assumption => assumption[ASSUMPTION_NAME])

    return assumptionsOptions.filter(
      option =>
        !selectedAssumptionsNames.includes(option.value) || option.value === values[ASSUMPTIONS][index][ASSUMPTION_NAME]
    )
  }, [values, index])

  const onClickHandler = useCallback(() => {
    if (isSelected) {
      onClose()
    } else {
      onSelect()
    }
  }, [isSelected, onSelect, onClose])

  return (
    <MinimisedSection
      headerContent={<MinimisedSectionHeader title={t(`Assumption ${index + 1}`)} onDelete={onDelete} />}
      isOpened={isSelected}
      onHeaderClick={onClickHandler}
    >
      <Field
        name={`${ASSUMPTIONS}[${index}][${ASSUMPTION_NAME}]`}
        formik={formik}
        options={availableAssumptionsOptions}
        placeholder="Assumption Name"
        className={classes.assumptionNameSelect}
      />
      <FieldLabelWrapper label={t('Drop Off')} labelFor={`${ASSUMPTIONS}[${index}][${DROP_OFF}]`}>
        <Field placeholder={t('Drop Off')} formik={formik} name={`${ASSUMPTIONS}[${index}][${DROP_OFF}]`} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Dead Weight')} labelFor={`${ASSUMPTIONS}[${index}][${DEAD_WEIGHT}]`}>
        <Field placeholder={t('Dead Weight')} formik={formik} name={`${ASSUMPTIONS}[${index}][${DEAD_WEIGHT}]`} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Attribution')} labelFor={`${ASSUMPTIONS}[${index}][${ATTRIBUTION}]`}>
        <Field placeholder={t('Attribution')} formik={formik} name={`${ASSUMPTIONS}[${index}][${ATTRIBUTION}]`} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Displacement')} labelFor={`${ASSUMPTIONS}[${index}][${DISPLACEMENT}]`}>
        <Field placeholder={t('Displacement')} formik={formik} name={`${ASSUMPTIONS}[${index}][${DISPLACEMENT}]`} />
      </FieldLabelWrapper>
    </MinimisedSection>
  )
}

AssumptionSection.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default AssumptionSection
